module.exports = __webpack_public_path__ + "img/记录回访.3a99fe8f.png";